import React from "react";

type ArticleAdSlotProps = {
  position: "mid" | "end";
  context?: "article" | "news" | "home";
};

export default function ArticleAdSlot({ position, context = "article" }: ArticleAdSlotProps) {
  const labels = {
    article: position === "mid" ? "مساحة إعلانية وسط المقال" : "مساحة إعلانية في نهاية المقال",
    news: position === "mid" ? "مساحة إعلانية في منتصف الأخبار" : "مساحة إعلانية في نهاية الأخبار",
    home: position === "mid" ? "مساحة إعلانية في منتصف الصفحة الرئيسية" : "مساحة إعلانية في نهاية الصفحة الرئيسية",
  } as const;
  return (
    <div
      className="article-ad-slot my-8 min-h-[90px] w-full rounded-2xl border border-dashed border-amber-200/20 bg-slate-950/25 px-4 py-6 text-center"
      data-monetag-banner-slot={`${context}-${position}`}
      aria-label={labels[context]}
    >
      <span className="text-xs text-slate-500">مساحة إعلانية</span>
    </div>
  );
}

export function getArticleAdSlotIds() {
  return ["article-mid", "article-end"] as const;
}
